/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeSessionDto
 */
export interface StripeSessionDto {
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    successUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    cancelUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    stripeSessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    stripePaymentIntentId?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSessionDto
     */
    stripeCustomerId?: string;
}

export function StripeSessionDtoFromJSON(json: any): StripeSessionDto {
    return StripeSessionDtoFromJSONTyped(json, false);
}

export function StripeSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeSessionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'successUrl': !exists(json, 'success_url') ? undefined : json['success_url'],
        'cancelUrl': !exists(json, 'cancel_url') ? undefined : json['cancel_url'],
        'stripeSessionId': !exists(json, 'stripe_session_id') ? undefined : json['stripe_session_id'],
        'stripePaymentIntentId': !exists(json, 'stripe_payment_intent_id') ? undefined : json['stripe_payment_intent_id'],
        'stripeCustomerId': !exists(json, 'stripe_customer_id') ? undefined : json['stripe_customer_id'],
    };
}

export function StripeSessionDtoToJSON(value?: StripeSessionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'success_url': value.successUrl,
        'cancel_url': value.cancelUrl,
        'stripe_session_id': value.stripeSessionId,
        'stripe_payment_intent_id': value.stripePaymentIntentId,
        'stripe_customer_id': value.stripeCustomerId,
    };
}

